import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { FavoriteStandardMedicine } from "../shared/services/models/medic/favorite-standard-medicine.model";
import { PrescriptionMedicineStruct } from "../shared/services/structs/pharmacy/prescription-medicine.struct";
import { FavoriteMedicatedSolutionStruct } from "../shared/services/structs/medic/favorite-medicated-solution.struct";
import { PrescriptionSolutionStruct } from "../shared/services/structs/pharmacy/prescription-solution.struct";
import { PrescriptionSolutionMedicineStruct } from "../shared/services/structs/pharmacy/prescription-solution-medicine.struct";
import { FavoriteMedicineToFavoriteStandardMedicineStruct } from "../shared/services/structs/medic/favorite-medicine-to-favorite-standard-medicine.struct";
import { GetListMedicineResponse } from "../shared/services/responses/pharmacy/getl-list-medicine.response";
import { TagStruct } from "../shared/components/tag/tag.struct";

@Injectable({
  providedIn: 'root'
})
export class UtilMedicService {
  constructor(private dialog: MatDialog) { }


  mapFavoriteToPrescriptionMedicine(medicine: FavoriteStandardMedicine, medicineData: GetListMedicineResponse | null = null): PrescriptionMedicineStruct {
    let auxPrescriptionMedicineStruct = new PrescriptionMedicineStruct();
    auxPrescriptionMedicineStruct.administrationTypeName = medicine.administrationTypeName;
    auxPrescriptionMedicineStruct.prescriptionMedicine.dilution = medicine.dilution;
    auxPrescriptionMedicineStruct.dilutionName = medicine.dilutionName;
    auxPrescriptionMedicineStruct.frequencyName = medicine.frequencyName;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idAdministrationType = medicine.idAdministrationType;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idDilution = medicine.idDilution;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idFrequency = medicine.idFrequency;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idMeasurementUnit = medicine.idMeasurementUnit;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idMedicine = medicine.idMedicine;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idPresentation = medicine.idPresentation;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idTreatmentPeriod = medicine.idTreatmentPeriod;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idUsage = medicine.idUsage;
    auxPrescriptionMedicineStruct.medicineName = medicine.medicineName;
    auxPrescriptionMedicineStruct.prescriptionMedicine.presentation = medicine.presentation;
    auxPrescriptionMedicineStruct.presentationName = medicine.presentationName;
    auxPrescriptionMedicineStruct.prescriptionMedicine.quantity = medicine.quantity;
    auxPrescriptionMedicineStruct.prescriptionMedicine.administrationType = medicine.administrationType;
    auxPrescriptionMedicineStruct.usage = medicine.usage;
    auxPrescriptionMedicineStruct.treatmentPeriodName = medicine.treatmentPeriodName;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idSubFrequency = medicine.idSubFrequency;
    auxPrescriptionMedicineStruct.subFrequencyName = medicine.subFrequencyName;
    auxPrescriptionMedicineStruct.prescriptionMedicine.idDilutionUnit = medicine.idDilutionUnit;
    auxPrescriptionMedicineStruct.prescriptionMedicine.dilutionQuantity = medicine.dilutionQuantity;
    auxPrescriptionMedicineStruct.dilutionUnitName = medicine.dilutionUnitName;
    auxPrescriptionMedicineStruct.prescriptionMedicine.observation = medicine.observation;
    if (medicineData != null) {
      auxPrescriptionMedicineStruct.listTags = medicineData.listMedicineStruct.find(c => c.medicine.idMedicine == medicine.idMedicine)?.medicine.tagMedicines.map(c => ({
        idTag: c.tag.idTag,
        tagName: c.tag.tagName,
        priority: c.tag.priority,
        colorCode: c.tag.colorCode,
        isDeleted: c.tag.isDeleted,
      }));
    }
    return auxPrescriptionMedicineStruct;
  }

  mapPrescriptionMedicineToFavorite(prescriptionMedicine: PrescriptionMedicineStruct, medicineData: GetListMedicineResponse | null = null): FavoriteStandardMedicine {
    let auxFavoriteStandardMedicine = new FavoriteStandardMedicine();
    auxFavoriteStandardMedicine.administrationTypeName = prescriptionMedicine.administrationTypeName;
    auxFavoriteStandardMedicine.dilution = prescriptionMedicine.prescriptionMedicine.dilution;
    auxFavoriteStandardMedicine.dilutionName = prescriptionMedicine.dilutionName;
    auxFavoriteStandardMedicine.frequencyName = prescriptionMedicine.frequencyName;
    auxFavoriteStandardMedicine.idAdministrationType = prescriptionMedicine.prescriptionMedicine.idAdministrationType;
    auxFavoriteStandardMedicine.idDilution = prescriptionMedicine.prescriptionMedicine.idDilution;
    auxFavoriteStandardMedicine.idFrequency = prescriptionMedicine.prescriptionMedicine.idFrequency;
    auxFavoriteStandardMedicine.idMeasurementUnit = prescriptionMedicine.prescriptionMedicine.idMeasurementUnit;
    auxFavoriteStandardMedicine.idMedicine = prescriptionMedicine.prescriptionMedicine.idMedicine;
    auxFavoriteStandardMedicine.idPresentation = prescriptionMedicine.prescriptionMedicine.idPresentation;
    auxFavoriteStandardMedicine.idTreatmentPeriod = prescriptionMedicine.prescriptionMedicine.idTreatmentPeriod;
    auxFavoriteStandardMedicine.idUsage = prescriptionMedicine.prescriptionMedicine.idUsage;
    auxFavoriteStandardMedicine.medicineName = prescriptionMedicine.medicineName;
    auxFavoriteStandardMedicine.presentation = prescriptionMedicine.prescriptionMedicine.presentation;
    auxFavoriteStandardMedicine.presentationName = prescriptionMedicine.presentationName;
    auxFavoriteStandardMedicine.quantity = prescriptionMedicine.prescriptionMedicine.quantity;
    auxFavoriteStandardMedicine.administrationType = prescriptionMedicine.prescriptionMedicine.administrationType;
    auxFavoriteStandardMedicine.usage = prescriptionMedicine.usage;
    auxFavoriteStandardMedicine.treatmentPeriodName = prescriptionMedicine.treatmentPeriodName;
    auxFavoriteStandardMedicine.idSubFrequency = prescriptionMedicine.prescriptionMedicine.idSubFrequency;
    auxFavoriteStandardMedicine.subFrequencyName = prescriptionMedicine.subFrequencyName;
    auxFavoriteStandardMedicine.idDilutionUnit = prescriptionMedicine.prescriptionMedicine.idDilutionUnit;
    auxFavoriteStandardMedicine.dilutionQuantity = prescriptionMedicine.prescriptionMedicine.dilutionQuantity;
    auxFavoriteStandardMedicine.dilutionUnitName = prescriptionMedicine.dilutionUnitName;
    auxFavoriteStandardMedicine.observation = prescriptionMedicine.prescriptionMedicine.observation;
    return auxFavoriteStandardMedicine;
  }

  mapFavoriteToPrescriptionSolution(solution: FavoriteMedicatedSolutionStruct, medicineData: GetListMedicineResponse | null = null): PrescriptionSolutionStruct {
    let auxPrescriptionSolutionStruct = new PrescriptionSolutionStruct();
    for (let index = 0; index < solution.listMedicine.length; index++) {
      let auxSolutionMedicine = new PrescriptionSolutionMedicineStruct();
      auxSolutionMedicine.prescriptionSolutionMedicine.idMedicine = solution.listMedicine[index].idMedicine;
      auxSolutionMedicine.prescriptionSolutionMedicine.quantity = solution.listMedicine[index].quantity;
      auxSolutionMedicine.prescriptionSolutionMedicine.idMeasurementUnit = solution.listMedicine[index].idMeasurementUnit;
      auxSolutionMedicine.medicineName = solution.listMedicine[index].medicineName;
      if (medicineData != null) {
        auxSolutionMedicine.listTags = medicineData.listMedicineStruct.find(c => c.medicine.idMedicine == solution.listMedicine[index].idMedicine)?.medicine.tagMedicines.map(c => ({
          idTag: c.tag.idTag,
          tagName: c.tag.tagName,
          priority: c.tag.priority,
          colorCode: c.tag.colorCode,
          isDeleted: c.tag.isDeleted,
        }));
      }
      auxPrescriptionSolutionStruct.listSolutionMedicine.push(auxSolutionMedicine);
    }

    auxPrescriptionSolutionStruct.prescriptionSolution.idDilutionUnit = solution.idDilutionUnit;
    auxPrescriptionSolutionStruct.prescriptionSolution.idSubFrequency = solution.idSubFrequency;
    auxPrescriptionSolutionStruct.prescriptionSolution.idAdministrationType = solution.idAdministrationType;
    auxPrescriptionSolutionStruct.prescriptionSolution.idDilution = solution.idDilution;
    auxPrescriptionSolutionStruct.prescriptionSolution.idFrequency = solution.idFrequency;
    auxPrescriptionSolutionStruct.prescriptionSolution.idPresentation = solution.idPresentation;
    auxPrescriptionSolutionStruct.prescriptionSolution.idTreatmentPeriod = solution.idTreatmentPeriod;
    auxPrescriptionSolutionStruct.prescriptionSolution.idUsage = solution.idUsage;
    auxPrescriptionSolutionStruct.administrationTypeName = solution.administrationTypeName;
    auxPrescriptionSolutionStruct.prescriptionSolution.administrationType = solution.administrationType;
    auxPrescriptionSolutionStruct.prescriptionSolution.dilution = solution.dilution;
    auxPrescriptionSolutionStruct.dilutionName = solution.dilutionName;
    auxPrescriptionSolutionStruct.frequencyName = solution.frequencyName;
    auxPrescriptionSolutionStruct.prescriptionSolution.presentation = solution.presentation;
    auxPrescriptionSolutionStruct.presentationName = solution.presentationName;
    auxPrescriptionSolutionStruct.treatmentPeriodName = solution.treatmentPeriodName;
    auxPrescriptionSolutionStruct.usage = solution.usage;
    auxPrescriptionSolutionStruct.subFrequencyName = solution.subFrequencyName;
    auxPrescriptionSolutionStruct.prescriptionSolution.dilutionQuantity = solution.dilutionQuantity;
    auxPrescriptionSolutionStruct.dilutionUnitName = solution.dilutionUnitName;
    auxPrescriptionSolutionStruct.prescriptionSolution.observation = solution.observation;

    return auxPrescriptionSolutionStruct;
  }

  mapPrescriptionSolutionToFavorite(prescriptionSolution: PrescriptionSolutionStruct): FavoriteMedicatedSolutionStruct {
    let auxFavoriteMedicatedSolutionStruct = new FavoriteMedicatedSolutionStruct();
    for (let index = 0; index < prescriptionSolution.listSolutionMedicine.length; index++) {
      let auxMedicine = new FavoriteMedicineToFavoriteStandardMedicineStruct();
      auxMedicine.idMedicine = prescriptionSolution.listSolutionMedicine[index].prescriptionSolutionMedicine.idMedicine;
      auxMedicine.quantity = prescriptionSolution.listSolutionMedicine[index].prescriptionSolutionMedicine.quantity;
      auxMedicine.idMeasurementUnit = prescriptionSolution.listSolutionMedicine[index].prescriptionSolutionMedicine.idMeasurementUnit;
      auxMedicine.medicineName = prescriptionSolution.listSolutionMedicine[index].medicineName;

      auxFavoriteMedicatedSolutionStruct.listMedicine.push(auxMedicine);
    }

    auxFavoriteMedicatedSolutionStruct.idDilutionUnit = prescriptionSolution.prescriptionSolution.idDilutionUnit;
    auxFavoriteMedicatedSolutionStruct.idSubFrequency = prescriptionSolution.prescriptionSolution.idSubFrequency;
    auxFavoriteMedicatedSolutionStruct.idAdministrationType = prescriptionSolution.prescriptionSolution.idAdministrationType;
    auxFavoriteMedicatedSolutionStruct.idDilution = prescriptionSolution.prescriptionSolution.idDilution;
    auxFavoriteMedicatedSolutionStruct.idFrequency = prescriptionSolution.prescriptionSolution.idFrequency;
    auxFavoriteMedicatedSolutionStruct.idPresentation = prescriptionSolution.prescriptionSolution.idPresentation;
    auxFavoriteMedicatedSolutionStruct.idTreatmentPeriod = prescriptionSolution.prescriptionSolution.idTreatmentPeriod;
    auxFavoriteMedicatedSolutionStruct.idUsage = prescriptionSolution.prescriptionSolution.idUsage;
    auxFavoriteMedicatedSolutionStruct.administrationTypeName = prescriptionSolution.administrationTypeName;
    auxFavoriteMedicatedSolutionStruct.administrationType = prescriptionSolution.prescriptionSolution.administrationType;
    auxFavoriteMedicatedSolutionStruct.dilution = prescriptionSolution.prescriptionSolution.dilution;
    auxFavoriteMedicatedSolutionStruct.dilutionName = prescriptionSolution.dilutionName;
    auxFavoriteMedicatedSolutionStruct.frequencyName = prescriptionSolution.frequencyName;
    auxFavoriteMedicatedSolutionStruct.presentation = prescriptionSolution.prescriptionSolution.presentation;
    auxFavoriteMedicatedSolutionStruct.presentationName = prescriptionSolution.presentationName;
    auxFavoriteMedicatedSolutionStruct.treatmentPeriodName = prescriptionSolution.treatmentPeriodName;
    auxFavoriteMedicatedSolutionStruct.usage = prescriptionSolution.usage;
    auxFavoriteMedicatedSolutionStruct.subFrequencyName = prescriptionSolution.subFrequencyName;
    auxFavoriteMedicatedSolutionStruct.dilutionQuantity = prescriptionSolution.prescriptionSolution.dilutionQuantity;
    auxFavoriteMedicatedSolutionStruct.dilutionUnitName = prescriptionSolution.dilutionUnitName;
    auxFavoriteMedicatedSolutionStruct.observation = prescriptionSolution.prescriptionSolution.observation;

    return auxFavoriteMedicatedSolutionStruct;
  }
}

